import { IndividualPlanPrintDialogStore } from './individual-plan-print-dialog.store';
import { fb, translate } from '../../../../../modules/shared/shared.global-service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { FilterBuilder } from '../../../../../modules/content/helper/filter.builder';
import { ServicePatternType } from '@libs/types/src/services/enum/service-pattern-type.enum';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { CheckInputComponent } from '../../../../kit/input/check-input/check-input.component';
import { SelectInputComponent } from '../../../../kit/input/select-input/select-input.component';
import { MultiSelectInputComponent } from '../../../../kit/input/multi-select-input/multi-select-input.component';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-individual-plan-print-dialog',
    templateUrl: './individual-plan-print-dialog.component.html',
    styleUrl: './individual-plan-print-dialog.component.scss',
    providers: [IndividualPlanPrintDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        CheckInputComponent,
        SelectInputComponent,
        MultiSelectInputComponent,
        DateInputComponent,
        TranslatePipe,
    ],
})
export class IndividualPlanPrintDialogComponent extends BaseDialogComponent {
    protected readonly store = inject(IndividualPlanPrintDialogStore);

    protected form = fb.group({
        archive: fb.control<boolean>(this.dialogConfig.data.archive ?? false),
        headerId: fb.control<number | null>(null, Validators.required),
        footerId: fb.control<number | null>(null, Validators.required),
        type: fb.control('current'),
        withOffers: fb.control(false),
        withTargets: fb.control(false),
        allOffers: fb.control('false'),
        allTargets: fb.control('false'),
        situation: fb.control(false),
        process: fb.control(false),
        evaluation: fb.control(false),
        work: fb.control(false),
        dateFrom: fb.control<Date | null>(null),
        dateTo: fb.control<Date | null>(null),
        tags: fb.control<string[]>([]),
    });

    protected processing: boolean = false;

    protected allOptions = [
        {
            name: translate.instant('individualPlan.print.active'),
            value: 'false',
        },
        { name: translate.instant('individualPlan.print.all'), value: 'true' },
    ];

    protected typeOptions = [
        {
            name: translate.instant('individualPlan.print.current'),
            value: 'current',
        },
        {
            name: translate.instant('individualPlan.print.allOf'),
            value: 'allOf',
        },
    ];

    private readonly serviceId = 0;
    private readonly folderId = 0;

    constructor() {
        super();

        this.serviceId = this.dialogConfig.data.serviceId;
        this.folderId = this.dialogConfig.data.folderId;
        this.fetchData();

        this.serviceId &&
            this.store.api
                .getServicePatterns(
                    FilterBuilder.singlePage({
                        serviceId: Number(this.serviceId),
                        type: ServicePatternType.DOCUMENT,
                    }),
                )
                .then();
    }

    protected print(): void {
        if (this.processing) return;
        this.processing = true;
        const value = {
            ...this.form.getRawValue(),
            allTargets: this.form.value.allTargets == 'true',
            allOffers: this.form.value.allOffers == 'true',
            serviceId: this.serviceId,
        };
        const callback =
            this.dialogConfig.data.onStart ?? this.dialogConfig.data.onPrint;
        Promise.resolve(callback(value))
            .then((started: boolean) => {
                if (started) this.dialogRef.close();
            })
            .finally(() => {
                this.processing = false;
            });
    }

    private fetchData(): void {
        this.store.api.getIndividualPlanFolderTags({ id: this.folderId });
    }
}
